export default "__VITE_ASSET__D0WL1a69__"